import { RouteMeta, Router, RouteRecordRaw } from 'vue-router'
import { moduleConfiguration } from '@/modules-configuration'
import { registerMiddlewares } from './middlewares/middlewares-registrator'

import { senndriveRoutes } from '@/modules/senndrive/routes'
import { analytics } from '@/services/analyticsProvider'
import { isModuleVisible } from '@/modules/visibility-handlers'
import { getStateData } from '@/store'

export const registerRoutesAndMiddlewares = (router: Router) => {
  router.addRoute({
    path: '/',
    redirect: '/senndrive',
  } as RouteRecordRaw)

  // Add senndrive routes
  for (const route of senndriveRoutes) {
    router.addRoute(route)
  }

  router.addRoute({
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import('../NotFound.vue'),
  })

  registerMiddlewares(router)

  router.beforeResolve((to) => {
    const { name, meta } = to
    setPageTitle(String(name), meta)
    if (meta.analyticsName) {
      analytics.trackPage(meta.analyticsName, {
        module: meta.analyticsName,
      })
    }
  })
}

export const getFirstVisibleModulePath = () => {
  const firstVisibleModule = moduleConfiguration.find((module) =>
    isModuleVisible(module, getStateData())
  )
  return firstVisibleModule?.route || '/not-found'
}

const setPageTitle = (name: string, meta: RouteMeta): void => {
  // TODO: Define the properly rules to name pages
  const pageName = meta.title || name.charAt(0).toUpperCase() + name.slice(1)
  document.title = `${pageName} |  App - Sennder`
}
